<template>
  <nav class="bg-light">

    <div class="sidebar-brand">
      PoolFit.tv
    </div>

    <div class="sidebar-inner">

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/">Dashboard</router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click.prevent="signOut">Sign out</a>
        </li>
      </ul>

      <div class="sidebar-heading">Content</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/banners">Banners</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/blogs">Blogs</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/instructors">Instructors</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/marketplace">Marketplace</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/media">Media</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/testimonials">Testimonials</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/tips">Tips</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/videos">Video Workouts</router-link>
        </li>
      </ul>

      <div class="sidebar-heading">Customers</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/users/filter/active">Active</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/users/filter/pending">Pending</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/users/filter/disabled">Disabled</router-link>
        </li>
      </ul>

      <div class="sidebar-heading">Categories</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/marketplace/categories">Marketplace</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/videos/categories">Videos</router-link>
        </li>
      </ul>

      <div class="sidebar-heading">Utilities</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/cloudfront-cdn-link-generator">Cloudfront URL tool</router-link>
        </li>
      </ul>

    </div>

  </nav>
</template>

<script>
import AccountService from "../services/AccountService";

export default {
  methods: {
    signOut() {
      AccountService.deleteSession();
      this.$router.push("/login");
    }
  },

  created() {
    AccountService.validateSession()
      .then(response => {
        if (response.data.enabled === 0) this.signOut();
      })
      .catch(() => this.signOut());
  }
};
</script>
